var gpu = {
    startTime: 0,
    frameNumber: 0,
    getFPS: function () {
        this.frameNumber++;
        var e = (new Date().getTime() - this.startTime) / 1e3,
            t = Math.floor(this.frameNumber / e);
        return e > 1 && ((this.startTime = new Date().getTime()), (this.frameNumber = 0)), t;
    },
    detect: function () {
        var e,
            t,
            r = document.createElement("canvas");
        try {
            e = r.getContext("webgl") || r.getContext("experimental-webgl");
        } catch (e) {
            return console.log(e), !1;
        }
        if (e) {
            var n = { renderer: "", vendor: "" };
            return (t = e.getExtension("WEBGL_debug_renderer_info")), (n.renderer = e.getParameter(t.UNMASKED_RENDERER_WEBGL)), (n.vendor = e.getParameter(t.UNMASKED_VENDOR_WEBGL)), n;
        }
        n = { renderer: "Unknown", vendor: "Unknown" };
        return console.error("WEBGL_RENDERER_CRASH - WebGL: Unavailable. Hardware acceleration unavailable."), n;
    },
};
function show(e) {
    e.style.display = "block";
}
function hide(e) {
    e.style.display = "none";
}
function setAll(e, t, r) {
    for (var n = 0; n < e.length; n++) e[n][t] = r;
}
function getRandomInt(e, t) {
    return Math.random() * (t - e) + e;
}
function multiSearchOr(e, t) {
    return new RegExp(t, "i").test(e);
}
function isEmpty(e) {
    var t = Object.prototype.hasOwnProperty;
    if (null == e) return !0;
    if (e.length > 0) return !1;
    if (0 === e.length) return !0;
    if ("object" != typeof e) return !0;
    for (var r in e) if (t.call(e, r)) return !1;
    return !0;
}
function isNumber(e) {
    return !isNaN(parseFloat(e)) && isFinite(e);
}
function resizeWallImage(e, t) {
    t = t;
    return ((e = e) > 512 || t > 512) && ((t *= 512 / e), (e = 512)), { width: e, height: t };
}
function openFullscreen() {
    var e = document.getElementById("WebGLContainer");
    e.requestFullscreen ? e.requestFullscreen() : e.mozRequestFullScreen ? e.mozRequestFullScreen() : e.webkitRequestFullscreen ? e.webkitRequestFullscreen() : e.msRequestFullscreen && e.msRequestFullscreen();
}
function imageLoaded(e) {
    return new Promise(function (t, r) {
        window.setTimeout(function () {
            var r = !1;
            !0 === e.complete && ((void 0 !== e.naturalWidth && 0 !== e.naturalWidth) || 0 !== e.width) && (r = !0), t(r);
        }, 0);
    });
}
